<template>
  <section class="container py-8">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-6 col-lg-4">
        <div class="rounded-3 shadow-sm bg-white border-0 overflow-hidden">
          <div class="bg-primary bg-opacity-10 p-5 text-center">
            <i class="ki-outline ki-check-circle text-primary fs-5x"/>
          </div>
          <div class="px-5 pb-5 pt-5">
            <h2 class="fw-semibold fs-3 text-dark mb-3 text-center">Счет на оплату отправлен</h2>
            <p class="text-muted mb-4 text-center fs-6">После оплаты, полис автоматически будет оформлен</p>
            <button type="button" class="btn btn-primary w-100 py-2 px-4 mb-2" @click="$router.push({ path: '/' })">
              Вернуться на главную
            </button>
            <button type="button" class="btn btn-primary w-100 py-2 px-4" @click="$router.push({ path: '/policies', query: { draft: policyNumber } })">
              Перейти к полису
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BpmOgpoPaymentSuccess',
  props: {
    policyNumber: {
      type: [String, Number],
      default: null,
    },
  },
}
</script>
